import React from 'react';
import PropTypes from 'prop-types';
import getArea from '@domain-group/fe-allhomes-library/lib/utils/get-area';
import BaseDetails from './base-details';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AreaDetails = _ref => {
  var icon = _ref.icon,
    label = _ref.label,
    value = _ref.value,
    note = _ref.note,
    approximate = _ref.approximate,
    className = _ref.className;
  var area = getArea(value);
  return ___EmotionJSX(BaseDetails, {
    label: label,
    icon: icon,
    className: className
  }, area.value, " ", area.unit, approximate && ___EmotionJSX("sup", null, "*"), " ", note && "(".concat(note, ")"));
};
AreaDetails.defaultProps = {
  note: null,
  approximate: false,
  icon: null,
  className: null
};
AreaDetails.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  note: PropTypes.string,
  approximate: PropTypes.bool,
  icon: PropTypes.func,
  className: PropTypes.string
};
export default AreaDetails;